<template>
  <v-dialog v-model="visible" width="835" @keydown.esc="visible = false" lazy>
    <div>
      <v-card>
        <v-card-title class="headline">
          <div class="headline">
            Report Jobs History
          </div>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-tabs>
            <v-tab ripple>
              Favourites
            </v-tab>
            <v-tab ripple>
              All
            </v-tab>
            <v-tab-item v-if="this.favInitState === 1">
              <v-container class="scroll-y rptHistoryPnl" id="rptHistoryPnl">
                <div v-scroll>
                  <v-layout row wrap>
                    <transition-group name="slide-x-transition" tag="div" class="flex">
                      <v-flex xs12 v-for="job in favJobs" :key="job.id">
                        <v-expansion-panel class="jobCard">
                          <v-expansion-panel-content>
                            <div slot="header">
                              <v-layout row align-center>
                                <v-btn icon @click.stop="removeFavourite(job)" title="Remove Favourite">
                                  <v-icon color="primary">{{ job.favourite ? 'mdi-star' : 'mdi-star-outline'}}</v-icon>
                                </v-btn>
                                <div class="jobContent">
                                  <div>
                                    {{job.customName}}
                                  </div>
                                  <div>
                                    <span class="grey--text">{{formatDateTime(job.effDate)}}</span>
                                  </div>
                                </div>
                                <div class="jobAction">
                                  <v-btn icon @click.stop="loadRptHistory(job.rptKeys)" title="Load Report Filters">
                                    <v-icon>mdi-content-copy</v-icon>
                                  </v-btn>
                                </div>
                              </v-layout>
                            </div>
                            <div>
                              <v-card>
                                <v-card-text>
                                  <v-container fluid grid-list-lg>
                                    <v-layout row wrap align-center class="rptKeys">
                                      <v-flex xs12 md6>
                                        <span class="grey--text body-2">ID: </span> {{job.id}}
                                      </v-flex>
                                      <v-flex xs12 md6></v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'proposalNo')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'proposalNo') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'proposalNo') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'certType')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'certType') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'certType') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfOriginalCopies')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'numberOfOriginalCopies') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'numberOfOriginalCopies') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfCopies')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'numberOfCopies') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'numberOfCopies') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfCopies')"></v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'intermediary')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'intermediary') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'intermediary') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'product')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'product') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'product') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'scheme')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'scheme') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'scheme') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'status')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'status') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'status') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'appID')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'appID') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'appID') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'clmStatus')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'clmStatus') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'clmStatus') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'duration')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'duration') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'duration') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'typeOfCover')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'typeOfCover') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'typeOfCover') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'businessSource')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'businessSource') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'businessSource') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'fromDate')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'fromDate') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'fromDate') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'toDate')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'toDate') }} </span>
                                        {{ extractValue(job.formattedRptKeys, 'toDate') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'toDate')"></v-flex>
                                      <v-flex xs12 md4>
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'format') }} </span>
                                        {{ extractValue(job.formattedRptKeys, 'format') }}
                                      </v-flex>
                                      <v-flex xs12 md4>
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'sendEmail') }} </span>
                                        {{ extractValue(job.formattedRptKeys, 'sendEmail') }}
                                      </v-flex>
                                      <v-flex xs12 md4></v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-divider></v-divider>
                      </v-flex>
                    </transition-group>
                  </v-layout>
                </div>
              </v-container>
            </v-tab-item>
            <v-tab-item v-else>
              <v-layout align-center justify-center v-if="this.favInitState === 0">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-layout>
              <v-layout align-center justify-center column v-else>
                <div>
                  <v-icon color="red">mdi-alert</v-icon> Failed to load Report History Favourites
                </div>
                <div class="pt-3">
                  <v-btn flat @click="doReloadFav">
                    Reload
                    <v-icon right>mdi-refresh</v-icon>
                  </v-btn>
                </div>
              </v-layout>
            </v-tab-item>
            <v-tab-item v-if="this.initState === 1">
              <v-container class="scroll-y rptHistoryPnl" id="rptHistoryPnl">
                <div v-scroll:#rptHistoryPnl="rptHistoryScroll">
                  <v-layout row wrap>
                    <transition-group name="slide-x-transition" tag="div" class="flex">
                      <v-flex xs12 v-for="job in jobs" :key="job.id">
                        <v-expansion-panel class="jobCard">
                          <v-expansion-panel-content>
                            <div slot="header">
                              <v-layout row align-center>
                                <v-btn icon @click.stop="toggleFavourite(job)" title="Favourite this job">
                                  <v-icon color="primary">{{ job.favourite ? 'mdi-star' : 'mdi-star-outline'}}</v-icon>
                                </v-btn>
                                <div class="jobContent">
                                  <div>
                                    {{job.customName}}
                                  </div>
                                  <div>
                                    <span class="grey--text">{{formatDateTime(job.effDate)}}</span>
                                  </div>
                                </div>
                                <div class="jobAction">
                                  <v-btn icon @click.stop="loadRptHistory(job.rptKeys)" title="Load Report Filters">
                                    <v-icon>mdi-content-copy</v-icon>
                                  </v-btn>
                                </div>
                              </v-layout>
                            </div>
                            <div>
                              <v-card>
                                <v-card-text>
                                  <v-container fluid grid-list-lg>
                                    <v-layout row wrap align-center class="rptKeys">
                                      <v-flex xs12 md6>
                                        <span class="grey--text body-2">ID: </span> {{job.id}}
                                      </v-flex>
                                      <v-flex xs12 md6></v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'proposalNo')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'proposalNo') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'proposalNo') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'certType')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'certType') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'certType') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfOriginalCopies')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'numberOfOriginalCopies') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'numberOfOriginalCopies') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfCopies')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'numberOfCopies') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'numberOfCopies') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'numberOfCopies')"></v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'intermediary')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'intermediary') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'intermediary') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'product')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'product') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'product') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'scheme')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'scheme') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'scheme') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'status')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'status') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'status') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'appID')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'appID') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'appID') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'clmStatus')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'clmStatus') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'clmStatus') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'duration')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'duration') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'duration') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'typeOfCover')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'typeOfCover') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'typeOfCover') }}
                                      </v-flex>
                                      <v-flex xs12 v-if="showRptKey(job.formattedRptKeys, 'businessSource')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'businessSource') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'businessSource') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'fromDate')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'fromDate') }}</span>
                                        {{ extractValue(job.formattedRptKeys, 'fromDate') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'toDate')">
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'toDate') }} </span>
                                        {{ extractValue(job.formattedRptKeys, 'toDate') }}
                                      </v-flex>
                                      <v-flex xs12 md4 v-if="showRptKey(job.formattedRptKeys, 'toDate')"></v-flex>
                                      <v-flex xs12 md4>
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'format') }} </span>
                                        {{ extractValue(job.formattedRptKeys, 'format') }}
                                      </v-flex>
                                      <v-flex xs12 md4>
                                        <span class="grey--text body-2">{{ extractLabel(job.formattedRptKeys, 'sendEmail') }} </span>
                                        {{ extractValue(job.formattedRptKeys, 'sendEmail') }}
                                      </v-flex>
                                      <v-flex xs12 md4></v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-text>
                              </v-card>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-divider></v-divider>
                      </v-flex>
                    </transition-group>
                  </v-layout>
                </div>
                <div v-if="$store.state.reports.rptHistoryList.loadingNewRptHistory">
                  <v-layout align-center justify-center text-xs-center>
                    <v-progress-circular indeterminate color="primary" :size="20"></v-progress-circular>
                    Loading...
                  </v-layout>
                </div>
              </v-container>
            </v-tab-item>
            <v-tab-item v-else>
              <v-layout align-center justify-center v-if="this.initState === 0">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-layout>
              <v-layout align-center justify-center column v-else>
                <div>
                  <v-icon color="red">mdi-alert</v-icon> Failed to load Report History Information
                </div>
                <div class="pt-3">
                  <v-btn flat @click="doReload">
                    Reload
                    <v-icon right>mdi-refresh</v-icon>
                  </v-btn>
                </div>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { REPORTS_HISTORY_INIT_LOADING, REPORTS_HISTORY_INIT_SUCCESS, REPORTS_HISTORY_INIT_FAIL, REPORTS_HISTORY_FAVOURITE_INIT_LOADING, REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS, REPORTS_HISTORY_FAVOURITE_INIT_FAIL, REPORTS_HISTORY_LOADMORE_LOADING, REPORTS_HISTORY_LOADMORE_SUCCESS, REPORTS_HISTORY_LOADMORE_FAIL, REPORTS_HISTORY_UPDATE, REPORTS_HISTORY_FAVOURITE_UPDATE } from '@/store/types'
import http, { expandURI } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime } from '@/utils/date'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      scrollable: true,
      visible: false,
      headers: [
        { text: 'No.', align: 'left', value: 'id' },
        { text: 'Report Name', align: 'left', value: 'name' },
        { text: 'Created Date', align: 'right', value: 'effDate' },
        { text: 'Action', align: 'right', value: '' }
      ]
    }
  },
  computed: {
    initState() {
      return this.$store.state.reports.rptHistoryList.init
    },
    favInitState() {
      return this.$store.state.reports.favRptHistoryList.init
    },
    jobs() {
      return this.$store.state.reports.rptHistoryList.jobs
    },
    favJobs() {
      return this.$store.state.reports.favRptHistoryList.jobs
    }
  },
  methods: {
    async init() {
      this.$store.commit(REPORTS_HISTORY_INIT_LOADING)

      const apiURI = this.$store.state.reports.menu.rptHistory
      if (apiURI) {
        try {
          const expand = {
            rptId: this.$props.id
          }
          const result = await http.get(expandURI(apiURI, expand))
          const menu = extractMenu(result.data._links)
          let commitResult = result.data
          Object.assign(commitResult, {
            menu: menu
          })
          this.$store.commit(REPORTS_HISTORY_INIT_SUCCESS, commitResult)
        } catch (error) {
          this.$store.commit(REPORTS_HISTORY_INIT_FAIL)
        }
      } else {
        this.$store.commit(REPORTS_HISTORY_INIT_FAIL)
      }
    },
    async initFav() {
      this.$store.commit(REPORTS_HISTORY_FAVOURITE_INIT_LOADING)

      const apiURI = this.$store.state.reports.menu.favRptHistory
      if (apiURI) {
        try {
          const expand = {
            rptId: this.$props.id
          }
          const result = await http.get(expandURI(apiURI, expand))
          const menu = extractMenu(result.data._links)
          let commitResult = result.data
          Object.assign(commitResult, {
            menu: menu
          })
          this.$store.commit(REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS, commitResult)
        } catch (error) {
          this.$store.commit(REPORTS_HISTORY_FAVOURITE_INIT_FAIL)
        }
      } else {
        this.$store.commit(REPORTS_HISTORY_FAVOURITE_INIT_FAIL)
      }
    },
    rptHistoryScroll(e) {
      const scrollHeight = e.target.scrollHeight - e.target.offsetHeight
      // Load when is 100px off the bottom
      const heightToLoad = scrollHeight - 100
      const scrollTop = e.target.scrollTop
      if (scrollTop >= heightToLoad) {
        this.loadMoreRptHistory()
      }
    },
    async loadMoreRptHistory() {
      if (!this.$store.state.reports.rptHistoryList.loadingNewRptHistory && this.$store.state.reports.rptHistoryList.hasNext) {
        this.$store.commit(REPORTS_HISTORY_LOADMORE_LOADING)

        const apiUrl = this.$store.state.reports.rptHistoryList.menu.next

        if (apiUrl) {
          try {
            const result = await http.get(apiUrl)
            const menu = extractMenu(result.data._links)
            let commitResult = result.data
            Object.assign(commitResult, {
              menu: menu
            })
            this.$store.commit(REPORTS_HISTORY_LOADMORE_SUCCESS, commitResult)
          } catch (error) {
            console.log(error)
            this.$store.commit(REPORTS_HISTORY_LOADMORE_FAIL)
          }
        } else {
          this.$store.commit(REPORTS_HISTORY_LOADMORE_FAIL)
        }
      }
    },
    toggleFavourite(item) {
      let tempFav = item.favourite
      if (tempFav === false) {
        tempFav = true
      } else {
        tempFav = false
      }
      const rptJob = {
        id: item.id,
        favourite: tempFav
      }
      this.$store.commit(REPORTS_HISTORY_UPDATE, rptJob)
      // Contact server to update to-do
      const apiUrl = this.$store.state.reports.rptHistoryList.menu.updateJob
      if (apiUrl) {
        try {
          const postData = {
            id: rptJob.id,
            favourite: rptJob.favourite
          }
          http.put(apiUrl, postData)
        } catch (error) {
          console.log(error)
        }
      }
    },
    removeFavourite(item) {
      const rptJob = {
        id: item.id,
        favourite: false
      }
      this.$store.commit(REPORTS_HISTORY_FAVOURITE_UPDATE, rptJob)
      // Contact server to update to-do
      const apiUrl = this.$store.state.reports.favRptHistoryList.menu.updateJob
      if (apiUrl) {
        try {
          const postData = {
            id: rptJob.id,
            favourite: rptJob.favourite
          }
          http.put(apiUrl, postData)
        } catch (error) {
          console.log(error)
        }
      }
    },
    doReload() {
      this.init()
    },
    doReloadFav() {
      this.favInit()
    },
    loadRptHistory(rptKeys) {
      this.$emit('close', rptKeys)
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    },
    showRptKey(formattedRptKeys, objectKey) {
      let result = false
      if (formattedRptKeys !== undefined && formattedRptKeys !== null && formattedRptKeys !== '') {
        JSON.parse(formattedRptKeys, (key, value) => {
          if (objectKey === key) {
            result = true
          }
        })
      }
      return result
    },
    extractLabel(formattedRptKeys, objectKey) {
      let result = ''
      if (formattedRptKeys !== undefined && formattedRptKeys !== null && formattedRptKeys !== '') {
        JSON.parse(formattedRptKeys, (key, value) => {
          if (objectKey === key && objectKey === 'proposalNo') {
            result = 'Proposal No: '
          } else if (objectKey === key && objectKey === 'certType') {
            result = 'Type of Certificate: '
          } else if (objectKey === key && objectKey === 'numberOfOriginalCopies') {
            result = 'No. of Original Copies: '
          } else if (objectKey === key && objectKey === 'numberOfCopies') {
            result = 'No. of Copies: '
          } else if (objectKey === key && objectKey === 'intermediary') {
            result = 'Intermediary: '
          } else if (objectKey === key && objectKey === 'product') {
            result = 'Product: '
          } else if (objectKey === key && objectKey === 'scheme') {
            result = 'Scheme: '
          } else if (objectKey === key && objectKey === 'status') {
            result = 'Status: '
          } else if (objectKey === key && objectKey === 'appID') {
            result = 'Claim Type: '
          } else if (objectKey === key && objectKey === 'clmStatus') {
            result = 'Claim Status: '
          } else if (objectKey === key && objectKey === 'duration') {
            result = 'Duration: '
          } else if (objectKey === key && objectKey === 'typeOfCover') {
            result = 'Type of Cover: '
          } else if (objectKey === key && objectKey === 'businessSource') {
            result = 'Business Source: '
          } else if (objectKey === key && objectKey === 'fromDate') {
            result = 'From Date: '
          } else if (objectKey === key && objectKey === 'toDate') {
            result = 'To Date: '
          } else if (objectKey === key && objectKey === 'format') {
            result = 'Format: '
          } else if (objectKey === key && objectKey === 'sendEmail') {
            result = 'Send Output as Email: '
          }
        })
      }
      return result
    },
    extractValue(formattedRptKeys, objectKey) {
      var temp
      if (formattedRptKeys !== undefined && formattedRptKeys !== null && formattedRptKeys !== '') {
        JSON.parse(formattedRptKeys, (key, value) => {
          if (objectKey === key) {
            temp = value
          }
        })
      }
      return temp
    }
  },
  watch: {
    'value': function (value) {
      this.visible = value
    },
    'visible': function (value) {
      if (!value) {
        // As this components using v-model to pass in value,
        // we have to emit back the value
        this.$emit('input', false)
      } else {
        // init here
        this.init()
        this.initFav()
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.rptHistoryPnl {
  max-height: 500px;
  width: 800px;
  &.container {
    padding: 0px;
  }
}
.jobCard {
  &:hover {
    cursor: pointer;
  }
  .jobContent {
    width: 90%;
  }
  .jobAction {
    width: 10%;
    text-align: center;
  }
  .rptKeys {
    padding-left: 20px;
  }
  .v-expansion-panel__header {
    height: auto !important;
  }
}
</style>
